import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Package } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Link, Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import { actionsReasons, supportEmail } from '@/returns/pages/TransactionDetailPage/constants'
import { getRetryLabelDisabledReason } from '@/returns/pages/TransactionDetailPage/helpers'

import * as Styles from './styles'

const RequestLabelTitle = ({ isDisabled, allowsGenerateLabelReason, pickupScheduled }) => {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const { info } = useContext(AppContext)

  const pickupScheduledReason = getRetryLabelDisabledReason({
    allowsGenerateLabelReason,
    pickupScheduled,
    t,
    language: i18n.language,
    timeZone: info?.selectedStore?.timezone,
  })

  return (
    <Styles.Container>
      <Styles.ActionTitleContainer>
        <Package size={16} />
        <Text type="bodyMRegular">{t('Solicitar nueva etiqueta')}</Text>
      </Styles.ActionTitleContainer>
      {isDisabled && (
        <Text type="bodySRegular" customStyles={{ paddingLeft: '25px' }} color={theme.colors.text.subtle}>
          {allowsGenerateLabelReason === actionsReasons.pickupScheduled && pickupScheduledReason}
          {allowsGenerateLabelReason === actionsReasons.maxReturnLabels && (
            <>
              {t('Ponte en contacto con nuestro equipo de soporte para solicitar etiquetas adicionales en')}{' '}
              <Link href={`mailto:${supportEmail}`}>
                <Text type="linkS">{supportEmail}</Text>
              </Link>
            </>
          )}
        </Text>
      )}
    </Styles.Container>
  )
}

export default RequestLabelTitle
